import { S3 } from '~models/s3'

const getFileKeys = async (preSignedPostResponse: S3.PreSignedPost[]) => {
  if (!preSignedPostResponse.length) {
    return []
  }

  return preSignedPostResponse.map(({ fields }) => fields.key)
}

export default getFileKeys
